import { ChatOpenAI } from '@langchain/openai';
import { ChatPromptTemplate, FewShotChatMessagePromptTemplate } from '@langchain/core/prompts';

import { getEnv } from '@lib/utils';

const model = new ChatOpenAI({
  model: 'gpt-4o',
  temperature: 0,
  apiKey: getEnv().OPENAI_API_KEY,
});

const chatPrompt = ChatPromptTemplate.fromMessages([
  [
    'system',
    `나는 제약사에 다니는 연구원이야. 약의 성분 및 효과에 대해서 잘 알고 있어. 답변을 만들때 설명서 처럼 딱딱하게 말하지 말고 친절한 약사처럼 알아 듣기 쉽게 설명할게.`,
  ],
  [
    'user',
    `나는 대한민국에 거주하고 있는 건강관리용 앱 기획자야. 나의 목표는 나의 앱 사용자들에게 유용한 건강 조언을 해주는 거야. 나는 영어를 못하기 때문에 답변 할때 한국어로 말해줘. "Let's think step by step" 넌 똑똑하고 잘 할 수 있어.`,
  ],
  ['system', `한번더 강조할께 나는 영어를 못하기 때문에 한국어로 말해줄게.`],
  ['user', '나의 질문에 대해 조언 예시와 똑같은 말투로 똑같이 개행해서 답해줘. {msg}'],
]);

const chatPromptForReport = ChatPromptTemplate.fromMessages([
  [
    'system',
    `나는 큰 병원에 다니는 의사야. 신체 변화와 건강나이에 대해 잘 알고 있어. 답변을 만들때 설명서 처럼 딱딱하게 말하지 말고 친절한 의사처럼 알아 듣기 쉽게 설명할게`,
  ],
  [
    'user',
    `나는 대한민국에 거주하고 있는 건강관리용 앱 기획자야. 나의 목표는 나의 앱 사용자들에게 유용한 건강 조언을 해주는 거야. 나는 영어를 못하기 때문에 답변 할때 한국어로 말해줘. "Let's think step by step" 넌 똑똑하고 잘 할 수 있어.`,
  ],
  ['system', `한번더 강조할께 나는 영어를 못하기 때문에 한국어로 말해줄게.`],
  [
    'user',
    '나의 질문에 대한 답변 중 제목은 제외한 내용으로만 해주고 한줄 긍정 문구 이후에 개행을 해줘. 측정된 값이 NULL 인 부분도 있을 수 있어. NULL이 있다면 해당 기간에 대한 설명은 제외하고 존재하고 있는 기간에 대해서만 내용을 구성해줘.{msg}',
  ],
]);

/**
 * 랭체인 메세지 전송
 * @param {*} msg
 * @returns
 */
export const sendAiMessage = async (msg) => {
  return await chatPrompt.pipe(model).invoke({ msg: msg });
};

/**
 * 랭체인 메시지 전송 for 건강나이 리포트
 * @param {*} msg
 * @returns
 */
export const sendAiMessageForReport = async (msg) => {
  return await chatPromptForReport.pipe(model).invoke({ msg: msg });
};
